import type { IUserCurrent } from './user.model';

export type UserAction = UserCurrentReceived | UserInfoReceived;

export interface UserCurrentReceived {
  type: 'USER_CURRENT_RECEIVED';
  userInfo: IUserCurrent;
}
export function userCurrentReceived(userInfo: IUserCurrent): UserCurrentReceived {
  return {
    type: 'USER_CURRENT_RECEIVED',
    userInfo,
  };
}

export interface UserInfoReceived {
  type: 'USER_INFO_RECEIVED';
  permissions: readonly Permission[];

  icId: string;
}

export function userInfoReceived(permissions: readonly Permission[], icId: string): UserInfoReceived {
  return {
    type: 'USER_INFO_RECEIVED',
    permissions,
    icId,
  };
}
